// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".m-authWelcome[data-v-7e4cb5d7]{max-height:100vh}.m-authWelcome__link[data-v-7e4cb5d7] a{color:var(--white)}.m-authWelcome__image-container[data-v-7e4cb5d7]{min-height:0}.m-authWelcome__image[data-v-7e4cb5d7]{flex:1;max-width:100%;min-width:0;-o-object-fit:contain;object-fit:contain}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
